import { render } from "./DirectDebitForm.vue?vue&type=template&id=3becd587&ts=true"
import script from "./DirectDebitForm.vue?vue&type=script&lang=ts"
export * from "./DirectDebitForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__